import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import sendOrderToWhatsApp  from '../../utils/whatsapp';

const CheckoutForm = ({ cartItems, totalPrice }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    address: '',
    city: '',
    notes: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phone || !formData.address) {
      alert('Please fill out all required fields.');
      return;
    }
    // Replace with target WhatsApp receiver phone number
    sendOrderToWhatsApp(formData, cartItems, totalPrice, '919000000000');
  };

  return (
    <form 
      onSubmit={handleSubmit} 
      className="bg-[#FDFBF7] rounded-3xl p-6 sm:p-8 border border-[#E8DFC8] shadow-sm space-y-5"
    >
      <h3 className="text-base font-serif font-bold text-[#4A0E17] border-b border-[#E8DFC8] pb-3">
        Delivery Details
      </h3>

      <div>
        <label className="block text-[11px] font-bold text-[#4A0E17] uppercase tracking-wider mb-1.5">
          Full Name *
        </label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Ananya Sharma"
          required
          className="w-full bg-[#F4EFE6] border border-[#E8DFC8] rounded-xl px-4 py-3 text-xs text-[#4A0E17] placeholder-[#7A6B5D]/60 outline-none focus:border-[#4A0E17] focus:ring-1 focus:ring-[#4A0E17]/20 transition-all"
        />
      </div>

      <div>
        <label className="block text-[11px] font-bold text-[#4A0E17] uppercase tracking-wider mb-1.5">
          WhatsApp Phone Number *
        </label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="+91 98765 43210"
          required
          className="w-full bg-[#F4EFE6] border border-[#E8DFC8] rounded-xl px-4 py-3 text-xs text-[#4A0E17] placeholder-[#7A6B5D]/60 outline-none focus:border-[#4A0E17] focus:ring-1 focus:ring-[#4A0E17]/20 transition-all"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-[11px] font-bold text-[#4A0E17] uppercase tracking-wider mb-1.5">
            Street Address *
          </label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="12 Heritage Enclave"
            required
            className="w-full bg-[#F4EFE6] border border-[#E8DFC8] rounded-xl px-4 py-3 text-xs text-[#4A0E17] placeholder-[#7A6B5D]/60 outline-none focus:border-[#4A0E17] focus:ring-1 focus:ring-[#4A0E17]/20 transition-all"
          />
        </div>

        <div>
          <label className="block text-[11px] font-bold text-[#4A0E17] uppercase tracking-wider mb-1.5">
            City *
          </label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="Bengaluru"
            required
            className="w-full bg-[#F4EFE6] border border-[#E8DFC8] rounded-xl px-4 py-3 text-xs text-[#4A0E17] placeholder-[#7A6B5D]/60 outline-none focus:border-[#4A0E17] focus:ring-1 focus:ring-[#4A0E17]/20 transition-all"
          />
        </div>
      </div>

      <div>
        <label className="block text-[11px] font-bold text-[#4A0E17] uppercase tracking-wider mb-1.5">
          Special Delivery Instructions (Optional)
        </label>
        <textarea
          name="notes"
          value={formData.notes}
          onChange={handleChange}
          rows="3"
          placeholder="Please request gift wrapping or specific delivery timings..."
          className="w-full bg-[#F4EFE6] border border-[#E8DFC8] rounded-xl px-4 py-3 text-xs text-[#4A0E17] placeholder-[#7A6B5D]/60 outline-none focus:border-[#4A0E17] focus:ring-1 focus:ring-[#4A0E17]/20 transition-all resize-none"
        />
      </div>

      <button
        type="submit"
        className="w-full bg-[#25D366] hover:bg-[#20ba5a] text-white py-4 rounded-2xl text-xs font-bold uppercase tracking-wider flex items-center justify-center space-x-2 transition-all shadow-md active:scale-95 border border-[#20ba5a]"
      >
        <MessageSquare className="w-4 h-4 fill-current" />
        <span>Place Order via WhatsApp</span>
      </button>
    </form>
  );
};

export default CheckoutForm;